module.exports = __webpack_public_path__ + "static/img/OOIATW20240826.a90d39d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OOIATW20240826.jpg
// module id = lRqj
// module chunks = 1